import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Spin } from 'antd';
import api from '@/services/api'; // Assuming you have a configured API service

const ContactTab = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const fetchSettings = async () => {
        setLoading(true);
        const query = "Address&Phone&Email&Whatsapp&FooterText&WorkingHours&FooterLocation&NewsletterBottom&CompanyName";

        try {
            const response = await api()({
                url: '/webshop/management/settings/multiple',
                method: 'GET',
                params: { query }
            });

            let obj = {};

            for (const item of response.data.data) {
                obj[item.Keyword] = item.Value;
            }

            setData(obj);
            form.setFieldsValue(obj);

        } catch (error) {
            console.error('Error fetching settings:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const onFinish = async (values) => {
        setLoading(true);

        try {
            await api()({
                url: '/webshop/management/settings',
                method: 'POST',
                data: {
                   data : values
                }
            })
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }

    };

    return (
        <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Address" name="Address">
                            <Input placeholder="1teststraat 1 23" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="E-Mail" name="Email">
                            <Input placeholder="test@test.nl" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Phone" name="Phone">
                            <Input placeholder="+31 6 12 34 56 78" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Whatsapp" name="Whatsapp">
                            <Input placeholder="+31 6 12 34 56 78" />
                        </Form.Item>
                    </Col>
              
                    <Col span={8}>
                        <Form.Item label="Working Hours" name="WorkingHours">
                            <Input placeholder="Mon–Sat 10:00pm - 7:00pm" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="Company Name" name="CompanyName">
                            <Input placeholder="Test BV" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Button type="primary" htmlType="submit">Save</Button>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
};

export default ContactTab;
